import React from 'react';

const Credits = () => {
  const principalNames = [
    ['Anna Bach', 'Arquitecta i docent'],
    ['Martí Delclòs'],
    ['Amir Rodergas'],
    ['Noelia Candón'],
    ['Anna Majó', 'Dissenyadora i docent'],
    ['Aura Olivan'],
    ['Mònica Ruiz'],
    ['Sara Barrull']
  ];

  const secondaryNames = [
    ['Cansons Studio', 'Estudi de gravació'],
    ['Sit Cantallops', 'Il·lustradora'],
    ['Marc Mittenhoff', 'Editor vídeo'],
    ['Nil Vila', 'Programador'],
    ['Pau Vinyals', 'Narrador']
  ];

  return (
      <section className="block block-credits">
        <div className="block-credits-principal">
          <h2 className="block-credits-title">Equip de disseny d’EINA</h2>
          <ul className="block-credits-names">
            {principalNames.map((name) => (
              <li key={name[0]}>
                <h1>
                  <span>{name[0].split(' ')[0]}</span>
                  <span>{name[0].split(' ')[1]}</span>
                </h1>
                <h3>{name[1] || 'Estudiant de disseny'}</h3>
              </li>
            ))}
          </ul>
        </div>
        <div className="block-credits-colaboradors">
          <h2 className="block-credits-title">Col·laboradors</h2>
          <ul className="block-credits-names">
            {secondaryNames.map((name) => (
              <li key={name[0]}>
                <h2>{name[0]}</h2>
                <h3>{name[1]}</h3>
              </li>
            ))}
          </ul>
        </div>
      </section>
  );
};

export default Credits;
